import { useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import { IListingRequest } from '@vivli/features/listing-request/infrastructure/interface';
import { IUtilityApi } from '@vivli/core/infrastructure/interface';

/// this class is for cases in which the FrontEnd needs to make an
/// api call of some sort directly to a BackEnd API - the calls in here
/// can come from any Backend API
export const useUtilityApi = (): IUtilityApi => {
    const { handlePut } = useAuthRestApi();
    //method to be used with emails except for those about listing requests
    const sendEmail = (objectToEmail: any, emailType: string): Observable<any> => {
        return handlePut<any>(`/email/${emailType}`, { objectToEmail });
    };

    //because ListingRequests need to be broken up currently, method for listing requests only
    const sendEmailForListingRequest = (listingRequest: IListingRequest, emailType: string): Observable<IListingRequest> => {
        const dataset = listingRequest.datasets[0];
        return handlePut<any>(`/email/listingRequest/${emailType}`, {
            listingRequest,
            dataset
        });
    };

    return {
        sendEmail,
        sendEmailForListingRequest
    };
};
